import React, {Component} from "react";
import {Dropdown, Menu} from "antd";
import {Link} from 'react-router-dom'
import {injectIntl} from "react-intl";
import Storage from '../services/Storage'
import './Header.css';

import logo from "../img/bmw-group-logo.png";
import connect from "react-redux/es/connect/connect";
import Constants from "../services/Constants";

const userMenu = (
  <Menu>
    <Menu.Item key="logout">
      <Link to={"/logout"}>Logout</Link>
    </Menu.Item>
    {
      Constants.SUPPORTED_LANGUAGES.map(lg => <Menu.Item key={lg} className={"ant-menu-selected"}><a
        href={`/?locale=${lg}`}>{lg}</a></Menu.Item>)
    }
  </Menu>
);

class Header extends Component {

  render() {
    const {intl: {formatMessage}, frontendConfig: {environment}} = this.props;
    const user = Storage.getItem('user');
    const dealerName = Storage.getItem('dn') || "";
    const locale = Storage.getItem('lg') || "en";
    const host = window.location.host.split('.').pop().toLowerCase();

    return (
      <header className="header" role="banner">
        <a href="/" className="header__logo">
          <img src={logo} alt="Service App Manager - Homepage"/>
          <span className="sr-only">Service App Manager - Homepage</span>
        </a>

        <h1 className="header__title">{formatMessage({id: 'overview.header.title'})}</h1>
        <div className="header__title" style={{float: 'right'}}>
          {environment && environment === "PRODUCTION" && <React.Fragment>
            <h2 className="header__title" style={{marginLeft: 'auto', fontSize: '1rem'}}>Support email BELUX: <a
              href="mailto:project24-7@bmw.be">project24-7@bmw.be</a> / <a
              href={this.props.frontendConfig[`dsa-bmw-${host}`][locale]} target="_blank">DSA</a></h2>
          </React.Fragment>
          }
        </div>

        <nav className="usernav">

          <ul className="usernav-menu">

            <li className="usernav-menu__item">

              <Dropdown overlay={userMenu} trigger={['click']}>
                <a className="usernav-menu__link">
                  {/*<img className="usernav-avatar" src="http://unsplash.it/32/32" alt="User avatar"/>*/}
                  {`${user.firstname} ${user.lastname}`}<br/>
                  {dealerName}
                  <svg className="bmw-icon-arrow-down">
                    <use xlinkHref="#icon-arrow-down"/>
                  </svg>
                </a>
              </Dropdown>
            </li>
          </ul>


        </nav>
      </header>
    )
  }
}


const mapStateToProps = state => ({
  authentication: state.authentication,
  frontendConfig: state.frontendConfig,
})

export default connect(
  mapStateToProps
)(injectIntl(Header));
